@if (showCreditInfo && myaccountPaymentDetails$ | async; as myaccount) {
<div class="myaccount-credit-info">
  <h2>{{ 'myAccount.creditInfo.title' | cxTranslate }}</h2>
  <div class="credit-info-wrapper">
    <div class="amount-due">
      <h3 class="credit-label">{{ 'myAccount.creditInfo.amountDue' | cxTranslate }}</h3>
      <p class="credit-info">{{ myaccount?.amountDue }}</p>
    </div>
    <div class="open-order-amount">
      <h3 class="credit-label">{{ 'myAccount.creditInfo.openOrderAmount' | cxTranslate }}</h3>
      <p class="credit-info">{{ myaccount?.openOrderAmount }}</p>
    </div>
    <div class="credit-limit">
      <h3 class="credit-label">{{ 'myAccount.creditInfo.creditLimit' | cxTranslate }}</h3>
      <p class="credit-info">{{ myaccount?.creditLimit }}</p>
    </div>
  </div>
</div>
} @if (myaccountPaymentDetails$ | async; as myaccount) {
<div class="myaccount-payment-details" [class.shows-credit-info]="showCreditInfo">
  <h2>{{ 'orderConfirmation.paymentDetails.title' | cxTranslate }}</h2>
  <div class="payment-wrapper">
    <div class="payment-method">
      <h3 class="payment-label">{{ 'orderConfirmation.paymentDetails.method' | cxTranslate }}</h3>
      <p class="payment-info">{{ myaccount?.paymentMode }}</p>
    </div>
    <div class="payment-terms">
      <h3 class="payment-label">{{ 'orderConfirmation.paymentDetails.terms' | cxTranslate }}</h3>
      <p class="payment-info">{{ myaccount?.paymentTerms }}</p>
    </div>
  </div>
</div>
}
